import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';

export const addAction = (budget) => ({
  type: ADD,
  budget,
});

export const addMultipleAction = (budgets) => ({
  type: ADD_MULTIPLE,
  budgets,
});

export const updateAction = (budget) => ({
  type: UPDATE,
  budget,
});

export const removeAction = (id) => ({
  type: REMOVE,
  id,
});
